<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumb" (goTo)="breadcrumbGoTo($event)"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="subscription-plans-edit-name">Name</label>
                <input
                  type="text"
                  [(ngModel)]="SubscriptionPlansData.name"
                  name="name"
                  #name="ngModel"
                  class="form-control"
                  id="subscription-plans-edit-name"
                  required
                  [readonly]="loading || SubscriptionPlansData.archivedAt"
                />
                <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.valid"> Name is invalid. </small>
              </div>

              <div class="form-group">
                <label for="subscription-plans-edit-amount">Amount</label>
                <input
                  type="number"
                  [(ngModel)]="SubscriptionPlansData.amount"
                  name="amount"
                  #amount="ngModel"
                  class="form-control"
                  id="subscription-plans-edit-amount"
                  required
                  [readonly]="loading || editMode"
                />
                <small class="text-danger" *ngIf="(amount.touched || amount.dirty) && !amount.valid"> Amount is invalid. </small>
              </div>

              <div class="form-group">
                <label for="currency-input">Currency</label>
                <input
                  id="currency-input"
                  [(ngModel)]="SubscriptionPlansData.currency"
                  name="currency"
                  class="form-control"
                  #currency="ngModel"
                  required
                  readonly
                />
                <small class="text-danger" *ngIf="errors.currency || ((currency.touched || currency.dirty) && !currency.valid)">
                  Currency is required.
                </small>
              </div>

              <div *ngIf="intervalTypes" class="form-group">
                <label for="interval-types-dropdown">Interval Unit</label>
                <select
                  id="interval-types-dropdown"
                  [(ngModel)]="SubscriptionPlansData.intervalUnit"
                  name="intervalUnit"
                  class="form-control"
                  #intervalUnit="ngModel"
                  required
                  [disabled]="loading || editMode"
                >
                  <option *ngFor="let interval of intervalTypes" [value]="interval"
                    ><span>{{ interval }} </span></option
                  >
                </select>
                <small
                  class="text-danger"
                  *ngIf="errors.intervalUnit || ((intervalUnit.touched || intervalUnit.dirty) && !intervalUnit.valid)"
                >
                  Interval Unit is required.
                </small>
              </div>

              <div class="form-group">
                <label for="subscription-plans-edit-interval-value">Interval Value</label>
                <input
                  type="number"
                  [(ngModel)]="SubscriptionPlansData.intervalValue"
                  name="intervalValue"
                  #intervalValue="ngModel"
                  class="form-control"
                  id="subscription-plans-edit-interval-value"
                  required
                  [readonly]="loading || editMode"
                />
                <small class="text-danger" *ngIf="(intervalValue.touched || intervalValue.dirty) && !intervalValue.valid"
                  >Interval Value is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="subscription-plans-edit-trial-period">Trial Period Days</label>
                <input
                  type="number"
                  [(ngModel)]="SubscriptionPlansData.trialPeriodDays"
                  name="trialPeriodDays"
                  #trialPeriodDays="ngModel"
                  class="form-control"
                  id="subscription-plans-edit-interval-value"
                  required
                  [readonly]="loading || editMode"
                />
                <small class="text-danger" *ngIf="(trialPeriodDays.touched || trialPeriodDays.dirty) && !trialPeriodDays.valid"
                  >Trial Period is invalid.
                </small>
              </div>

              <div *ngIf="types" class="form-group">
                <label for="plan-types-dropdown">Types</label>
                <select
                  id="plan-types-dropdown"
                  [(ngModel)]="SubscriptionPlansData.type"
                  name="type"
                  class="form-control"
                  #type="ngModel"
                  required
                  [disabled]="loading || editMode"
                >
                  <option *ngFor="let type of types" [value]="type.planType"
                    ><span>{{ type.planType }} </span></option
                  >
                </select>
                <small class="text-danger" *ngIf="errors.type || ((type.touched || type.dirty) && !type.valid)">
                  Plan type is required.
                </small>
              </div>

              <div *ngIf="coupons" class="form-group">
                <label for="plan-coupons-dropdown">Coupon</label>
                <select
                  id="plan-coupons-dropdown"
                  [(ngModel)]="SubscriptionPlansData.couponId"
                  name="couponId"
                  class="form-control"
                  #couponId="ngModel"
                  [disabled]="loading || SubscriptionPlansData.archivedAt"
                >
                  <option *ngFor="let coupon of coupons" [value]="coupon.id"
                    ><span>{{ coupon.name }} </span></option
                  >
                </select>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    id="default-checkbox"
                    (change)="markDefault(defaultCh.checked)"
                    #defaultCh
                    type="checkbox"
                    name="default"
                    [(ngModel)]="SubscriptionPlansData.isDefault"
                    class="custom-control-input"
                    [disabled]="loading || SubscriptionPlansData.archivedAt"
                  />
                  <label class="custom-control-label" for="default-checkbox">Is Default?</label>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    id="raf-default-checkbox"
                    (change)="markRafDefault(rafDefaultCh.checked)"
                    #rafDefaultCh
                    type="checkbox"
                    name="rafDefault"
                    [(ngModel)]="SubscriptionPlansData.isRafDefault"
                    class="custom-control-input"
                    [disabled]="loading || SubscriptionPlansData.archivedAt"
                  />
                  <label class="custom-control-label" for="raf-default-checkbox">Is RAF Default?</label>
                </div>
              </div>

              <div style="margin-top: 40px;">
                <button id='subscriptionPlansEditDelete' type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <button id='subscriptionPlansEditArchive' type="button" class="btn btn-warning" (click)="archive()" [disabled]="loading" *ngIf="!SubscriptionPlansData.archivedAt">Archive</button>
                <button id='subscriptionPlansEditUnarchive' type="button" class="btn btn-warning" (click)="unarchive()" [disabled]="loading" *ngIf="SubscriptionPlansData.archivedAt">Unarchive</button>
                <span class="btn-right">
                  <button id='subscriptionPlansEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='subscriptionPlansEditSave' type="submit" class="btn btn-primary" [disabled]="loading" *ngIf="!SubscriptionPlansData.archivedAt">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/subscription-plans/subscription-plans-edit/subscription-plans-edit.component.html